'use strict';
export const AnalyticsEventType = {
  DATA_VALIDATION_ERROR: ['dataValidationError'],
  ANALYTICS_DATA_UPDATE: ['analyticsDataUpdate', 'dataStateChange']
};

